import React from 'react';
import { css } from '@emotion/css';

import { pxToRem } from '../../system-libraries/styles/utils';
import { mqBreakpoints, MAX_DESKTOP_WIDTH_REM } from '../../system-libraries/styles/constants';
import Config from '../../system-utils/config-manager';

type Props = {
  text?: string;
};

export const HeaderBanner: React.FC<Props> = ({ text }) => {
  return (
    <div className={styles.headerBanner} data-testid='nba-header-banner'>
      <div className={styles.containter}>
        <div className={styles.text}>
          {text ? (
            text
          ) : (
            <>
              <img src={Config.get('image_cdn_base_url') + '/ui/shared-component-webapp/banner/m.svg'} className={styles.iconLetterM} />
              -Track
            </>
          )}
        </div>
        <img src={Config.get('image_cdn_base_url') + '/ui/shared-component-webapp/banner/pattern.svg'} className={styles.icon} />
      </div>
    </div>
  );
};

const styles = {
  headerBanner: css({
    backgroundColor: 'var(--color-dark)',
    flexShrink: 0,
    height: pxToRem(108),
    margin: '0 auto',
    width: '100%',
    [mqBreakpoints.tablet]: {
      height: pxToRem(160),
    },
  }),
  containter: css({
    margin: '0 auto',
    color: 'var(--color-white)',
    fontSize: pxToRem(18),
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingLeft: pxToRem(50),
    width: '100%',
    height: '100%',
    maxWidth: MAX_DESKTOP_WIDTH_REM,
    [mqBreakpoints.tablet]: {
      paddingLeft: pxToRem(48),
    },
    [mqBreakpoints.desktop]: {
      paddingLeft: pxToRem(165),
    },
  }),
  text: css({
    color: 'var(--color-secondary)',
    fontFamily: 'var(--font-loop)',
    fontSize: pxToRem(36),
    fontWeight: 'var(--font-weight-regular)',

    [mqBreakpoints.tablet]: {
      fontSize: pxToRem(54),
    },
  }),
  icon: css({
    height: '100%',
    marginRight: pxToRem(22),
    [mqBreakpoints.tablet]: {
      marginRight: pxToRem(48),
    },
    [mqBreakpoints.desktop]: {
      marginRight: pxToRem(55),
    },
  }),
  iconLetterM: css({
    width: pxToRem(28),
    height: pxToRem(26),

    [mqBreakpoints.tablet]: {
      width: pxToRem(41),
      height: pxToRem(39),
    },
  }),
};
